import { render, staticRenderFns } from "./ContractHeader.vue?vue&type=template&id=3ec560f1"
import script from "./ContractHeader.vue?vue&type=script&lang=js"
export * from "./ContractHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports